import { render, staticRenderFns } from "./AccountContacts.vue?vue&type=template&id=085e29e8&"
import script from "./AccountContacts.vue?vue&type=script&lang=js&"
export * from "./AccountContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports